import { IPromoCodeSummary } from './initialState';
import { IPromoCodeReportListItem, PaginationResponse } from '@ready/dashboardv2api.contracts';
import { IPagedResponse } from '@ready/table.core';
import { ILocation } from '../../../services/types/ILocation.type';

export const fetchPromoCodeSummaryReducers = {
  pending: (state: IPromoCodeSummary) => {
    state.loading.list = true;
  },
  fulfilled: (state: IPromoCodeSummary, action: { payload: PaginationResponse<IPromoCodeReportListItem> }) => {
    const { items, total, limit, start, length } = action.payload;
    state.loading.list = false;
    state.items = items;
    state.pagination = { total, limit, start, length };
  },
  rejected: (state: IPromoCodeSummary) => {
    state.loading.list = false;
    state.errors.list = 'Unable to retrieve Promo Code Summary list.';
  },
};

export const exportPromoCodeSummaryReducers = {
  pending: (state: IPromoCodeSummary) => {
    state.loading.export = true;
  },
  fulfilled: (state: IPromoCodeSummary) => {
    state.loading.export = false;
  },
  rejected: (state: IPromoCodeSummary) => {
    state.loading.export = false;
  },
};

export const fetchPermittedLocationsReducers = {
  pending: (state: IPromoCodeSummary) => {
    state.loading.permittedLocations = true;
  },
  fulfilled: (state: IPromoCodeSummary, action: { payload: IPagedResponse<ILocation> }) => {
    state.loading.permittedLocations = false;
    state.permittedLocations = action.payload;
  },
  rejected: (state: IPromoCodeSummary) => {
    state.loading.permittedLocations = false;
  },
};
